import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useSite, FALLBACK_SETTINGS } from "@/lib/content";

export default function CtaSection({
  title = "Have an idea? Let's build what comes next.",
  subtitle = "Tell us about your project, your workflow, or the problem you're trying to solve. We'll respond with clear next steps.",
}) {
  const { data } = useSite();
  const email = data?.settings?.email || FALLBACK_SETTINGS.email;

  return (
    <section className="relative overflow-hidden bg-void py-28 sm:py-36" data-testid="cta-section">
      <div className="hero-radial absolute inset-0" />
      <div className="bg-grid absolute inset-0 opacity-60 [mask-image:radial-gradient(ellipse_at_center,black_20%,transparent_70%)]" />
      <Reveal className="relative mx-auto max-w-4xl px-6 text-center lg:px-10">
        <h2 className="font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
          {title}
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">{subtitle}</p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/contact"
            data-testid="cta-start-project-btn"
            className="group inline-flex items-center gap-2 rounded-full bg-blue-600 px-8 py-4 text-sm font-semibold text-white shadow-[0_0_36px_rgba(59,130,246,0.45)] transition-[background-color,box-shadow,transform] duration-300 hover:bg-blue-500 hover:shadow-[0_0_48px_rgba(59,130,246,0.6)] active:scale-[0.98]"
          >
            Start Your Project
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <a
            href={`mailto:${email}`}
            data-testid="cta-email-link"
            className="inline-flex items-center gap-2 rounded-full border border-slate-700 px-8 py-4 text-sm font-semibold text-slate-200 transition-[border-color,background-color] duration-300 hover:border-blue-500/60 hover:bg-slate-800/40"
          >
            <Mail size={16} className="text-blue-400" />
            {email}
          </a>
        </div>
      </Reveal>
    </section>
  );
}
